/* eslint-disable */
import store from '@/store/index'

const userId = store.state.common.sessionInfo.userId
const sessionStr = store.state.common.sessionInfo.sessionStr
const firmId = store.state.common.sessionInfo.firmId
const firmCode = store.state.common.sessionInfo.firmCode
const tel = store.state.common.sessionInfo.tel
let bankServe = '/abc-bank-channel'
if (window.g.Bank_Id === 39) {
  bankServe = '/xy-bank-channel'
} else if (window.g.Bank_Id === 35) {
  bankServe = '/base-bankchannel'
} else if (window.g.Bank_Id === 37) {
  bankServe = '/sn-bank-channel'
} else if (window.g.Bank_Id === 24) {
  bankServe = '/gz-cp-bank-channel'
}
export default {
  // 因为页面有跳转三方界面，不能直定义变量存储，统一放到sessionStorage中
  // huoqu图片验证码
  param_getCaptcha: {
    url: '/authn/authn/generateCaptcha',
    param: {}
  },
  // 登录
  param_login: {
    url: '/authn/authn/login',
    param: {
      captchaCode: '',
      password: '',
      terminalType: 4,
      type: 1,
      captchaId: ' ',
      capid: '',
      code: '11234',
      userType: 'T',
      marketId: '', // 市场id
      marketId: 28
    }
  },
  // 退出
  param_logout: {
    url: '/authn/authn/v1/logout',
    param: {
      terminalType: 4,
      sessionStr: sessionStr,
      userId: userId,
      userid: userId
    }
  },
  // 修改密码
  param_newUpdatePwdByOld: {
    url: '/authn/authn/v1/simpleFrontUpdatePwdInFlow',
    param: {
      loginAccount: null,
      oldPassword: null,
      password: null
    }
  },
  // 修改资金密码
  // 修改资金密码
  param_updateFundPwd: {
    // url: '/intraday-marketing-system/operate/updateFundPwd',
    url: '/intraday-margin-manage/operate/updateFundPwdGs',
    param: {
      cellphone: null,
      oldPwd: null,
      newPassWord: null,
      bankId: null
    }
  },
  // 账号状态
  param_findUserStatusProcess: {
    url: '/base-desk-manage/queryAuthentication/v2/queryPlus',
    // url: '/intraday-trade-query-mongo/frontTradeController/findUserStatusProcess',
    param: {}
  },
  // 查询风险阈值
  param_findTqRisk: {
    url: '/intraday-trade-query/risk/findTqRisk',
    param: {}
  },
  // 判断是企业开户/个人开户 开户类型： 1-个人开户 2-企业开户 0-未开户
  param_getOrgOrPerson: {
    url: '/base-desk-manage/userAuth/getOrgOrPerson',
    param: {}
  },
  // 查询资金流水 --- 新
  param_queryFirmAccountFundsFlow: {
    url: '/base-margin-front-queryservice/margin/queryFirmAccountFundsFlow',
    param: {}
  },
  // 出入金 --- 新
  param_queryFirmBankAccountInoutFundsFlowFront: {
    url: '/base-margin-front-queryservice/margin/queryFirmBankAccountInoutFundsFlowFront',
    param: {}
  },
  // 查询资金状况（所有市场）
  param_findMyAsset: {
    url: '/base-margin-front-queryservice/margin/findMyAsset',
    param: {}
  },
  // f10查看商品资料
  param_findCommodityDetail: {
    url: '/intraday-trade-query/commodity/findCommodityDetail',
    param: {}
  },
  // 查询资金划转
  param_queryFundsTransfer: {
    url: '/base-margin-front-queryservice/margin/queryFundsTransfer',
    param: {}
  },
  // 银行开户信息查询
  param_findTrader: {
    url: '/intraday-margin-query/bankCacheQuery/findTrader',
    param: {}
  },
  // 银行签约信息查询
  param_findBankInfo: {
    url: '/intraday-margin-query/bankCacheQuery/findBankInfo',
    param: {}
  },
 
  // 返回视频认证次数
  param_authnVideoQuantity: {
    url: '/base-desk-manage/baseVideoVerify/authnVideoQuantity',
    param: {}
  },
   // 查询当前用户是否注册
   param_getCellphoneExists: {
    url: '/base-desk-query/baseUserAudit/v1/getCellphoneExists',
    param: {}
  },
  // 新注册
  param_register: {
    url: '/intraday-marketing-system/frontUserMaintainController/registerUser',
    param: {
      captchaCode: '',
      captchaId: '',
      code: '',
      createWay: 2, // 开户通道 1 管理后台 2 网上开户
      marketId: 28,
      mobilePhone: '',
      lnviteCode: '',
      password: '',
      userName: '', // 用户名称
      userType: 1 // 用户类型 A:交易所管理用户 M:会员管理用户 T:交易员
    }
  },
  // 获取短信验证码 用于注册
  param_getCaptchabyMobiletoRegister: {
    url: '/authn/authn/sendCaptcha',
    param: {
      loginAccount: '',
      mark: 'SMS_179220765', // 根据短信模版固定
      id: '2'
    }
  },
  // 查询是否是主力合约
  param_findCommodityIsMain: {
    url: '/intraday-trade-query/commodity/findCommodityIsMain',
    param: {
      commodityIsMain: 0
    }
  },
  // Integer id;
  // Integer commodityId;
  // Integer commodityIsMain;//是否是主力合约 0：是 1：不是
  //   //获取短信验证码 用于注册
  //   param_getmessagesAuth: {
  //     "url":"/bcnbasebizproxy/base/getmessagesAuth",
  //     "param": {
  //       "cellPhone": "",
  //     }
  //   },
  // 获取短信验证码 用于注册
  param_getmessagesAuth: {
    url: '/authn/authn/sendCaptcha',
    param: {
      loginAccount: '',
      id: '2'
    }
  },
  // 忘记密码
  param_forgetPwd: {
    url: '/authn/authn/updateUserPassword',
    param: {
      loginAccount: '', //	用户名
      password: '',
      captchaCode: '', // 图形验证码
      captchaId: '', // 验证码序列号
      code: '' // 短信/邮箱验证码
    }
  },
  // 修改密码
  param_updatePassword: {
    url: '/authn/authn/updatePwdByOld',
    param: {
      sessionStr: sessionStr,
      userId: userId,
      loginAccount: '',
      password: '',
      oldPassword: ''
    }
  },
  param_updatePwdByOld: {
    url: '/intraday-marketing-system/frontUserMaintainController/updatePwdByOld',
    param: {
      sessionStr: sessionStr,
      userId: userId,
      loginAccount: '',
      password: '',
      oldPassword: '',
      templateId: 31
    }
  },
  // 上传图片，现在没有用
  param_uploadImage: {
    url: '/uploadfile/upload/base64',
    param: {
      sessionStr: sessionStr,
      userId: userId,
      var1: '',
      var2: '',
      var3: '',
      startDate: '',
      stopDate: ''
    }
  },
  // 交易接口
  param_trades: {
    url: '/intraday-trade/trade/make',
    param: {
      bsFlag: null,
      commodityId: '',
      price: '',
      quantity: ''
    }
  },
  // 交易接口 (市价)
  param_marketTake: {
    url: '/intraday-trade/trade/marketTake',
    param: {
      bsFlag: null,
      commodityId: '',
      quantity: ''
    }
  },
  // 历史成交
  // 查询公告信息 获得某个栏目下的内容标题列表 get
  param_getArticle: {
    url: '/content/content/content',
    param: {
      page: '1',
      size: '20',
      columnId: '3',
      sort: 'createTime,desc'
    }
  },
  // 资讯 -> 查询公告列表 // 2020:11:10
  param_noticeList: {
    // url: '/content/content/noticeList',
    url: '/content/content/noticeList',
    param: {
      page: '1',
      size: '20',
      sort: 'createTime,desc'
    }
  },
  // 资讯 -> 获得详细内容
  param_getContentDetails: {
    // url: '/content/content/getContent',
    url: '/content/content/getContent',
    param: {
      id: null
    }
  },
  // 撤单
  withdrawLimitOrder: {
    url: '/intraday-trade/trade/cancel',
    data: {
      orderId: '' // 订单号
    }
  },
  // 全部撤单
  cancelAll: {
    url: '/intraday-trade/trade/cancelAll',
    data: {
      // commodityId: '' // 商品号
    }
  },
  // 撤买卖撤单
  cancelFlag: {
    url: '/intraday-trade/trade/cancelFlag',
    data: {
      bsFlag: null
      // commodityId: '' // 商品号
    }
  },
  // 撤最后一笔
  cancelLastOrder: {
    url: '/intraday-trade/trade/cancelLastOrder',
    data: {
      // commodityId: '' // 商品号
    }
  },
  // 撤预埋单
  cancelYM: {
    url: '/intraday-trade/trade/cancelAllByListForM',
    data: {
      // commodityId: '' // 商品号
      orderIdList: [] // 委托id List
    }
  },
  // 多选撤单
  param_cancelFast: {
    url: '/intraday-trade/trade/cancelFast',
    data: {
      orderList: '' // 订单号
    }
  },
  // 委托查询 新
  queryUserEntrustsNew: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryOrderNewFront',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId,
      bsFlag: null,
      // "commodityId": "1",
      orderType: null,
      sort: [
        {
          direction: 'DESC',
          property: 'orderId'
        }
      ]
    }
  },
  // 委托查询
  queryUserEntrusts: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryOrderFront',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId,
      bsFlag: null,
      // "commodityId": "1",
      orderType: null,
      sort: [
        {
          direction: 'DESC',
          property: 'orderId'
        }
      ]
    }
  },
  // 委托历史
  queryUserEntrustHS: {
    url: '/base-desk-statement/tradeQueryH/queryOrderFrontH',
    data: {
      page: '0',
      size: '20',
      bsFlag: null,
      // "commodityId": "1",
      orderType: null,
      sort: [
        {
          direction: 'DESC',
          property: 'orderId'
        }
      ]
    }
  }, 
  // 委托历史 新
  queryUserEntrustHSNEW: {
    url: '/base-desk-statement/tradeQueryH/queryOrderFrontH',
    data: {
      page: '0',
      size: '20',
      bsFlag: null,
      // "commodityId": "1",
      orderType: null,
      sort: [
        {
          direction: 'DESC',
          property: 'orderId'
        }
      ]
    }
  },
  // 委托查询合计
  queryOrderFrontSum: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryOrderFrontSum',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId,
      bsFlag: null,
      // "commodityId": "1",
      orderType: null,
      sort: [
        {
          direction: 'DESC',
          property: 'create_time'
        }
      ]
    }
  },
  // 历史查询合计
  queryOrderFrontHSum: {
    url: '/base-desk-statement/tradeQueryH/sumOrderFrontH',
    data: {
      // firmId: firmId,
      bsFlag: null,
      commodityId: null,
      // orderType: null,
      startTradeDay: null,
      endTradeDay: null
    }
  },
  // 历史成交合计
  queryTradeFrontHSum: {
    url: '/base-desk-statement/tradeQueryH/sumTradeFrontH',
    data: {
      // firmId: firmId,
      bsFlag: null,
      commodityId: null,
      // orderType: null,
      startTradeDay: null,
      endTradeDay: null
    }
  },
  // 成交查询 排序字段无效
  queryUserClinchesNew: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryTradeNewList',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId,
      // "commodityId": "1",
      tradeType: null,
      "sort": [{
        "direction": "DESC",
        "property": "tradeId"
      }]
    }
  },
  // 成交查询 排序字段无效
  queryUserClinches: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryTradeList',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId,
      // "commodityId": "1",
      tradeType: null,
      "sort": [{
        "direction": "DESC",
        "property": "tradeId"
      }]
    }
  },
  // 成交查询 合计
  queryTradeListSum: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryTradeListSum',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId,
      // "commodityId": "1",
      tradeType: null
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "createTime"
      // }]
    }
  },
  // 持仓明细
  queryUserHoldingsSubsidiariesNew: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryHoldDetailNewList',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId
      // "commodityId": "1",
      "sort": [{
        "direction": "DESC",
        "property": "holdDetailId"
      }]
    }
  },
  // 持仓明细
  queryUserHoldingsSubsidiaries: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryHoldDetailList',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId
      // "commodityId": "1",
      "sort": [{
        "direction": "DESC",
        "property": "holdDetailId"
      }]
    }
  },
  // 持仓汇总
  queryUserPositionSummariesNew: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryHoldNewFront',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId,
      // "commodityId": "1",
      bsFlag: null,
      holdNo: null,
      "sort": [{
        "direction": "DESC",
        "property": "holdId"
      }]
    }
  },
  // 持仓汇总
  queryUserPositionSummaries: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryHoldFront',
    data: {
      page: '0',
      size: '20',
      // firmId: firmId,
      // "commodityId": "1",
      bsFlag: null,
      holdNo: null,
      "sort": [{
        "direction": "DESC",
        "property": "holdId"
      }]
    }
  },
  // 持仓汇总合计
  queryHoldFrontSum: {
    url: '/intraday-trade-query-mongo/tradeQuery/queryHoldFrontSum',
    data: {
      // 'page': '0',
      // 'size': '20',
      // firmId: firmId
      // "commodityId": "1",
      // "sort": [{
      //   "direction": "DESC",
      //   "property": "openTime"
      // }]
    }
  },
  // 确认风险提示
  confirmRiskWarning: {
    url: '/intraday-marketing-system/frontTradeController/confirmRiskWarning',
    data: {}
  },
  // 确认风险提示(获取状态)
  param_confirmRiskWarningStatus: {
    url:
      '/intraday-marketing-system/frontTradeController/getConfirmRiskWarningStatus',
    param: {}
  },
  // 判断当前用户是否修改过资金密码
  param_getMoneyPwdFlgByFirmId: {
    url: '/intraday-marketing-system/operate/getMoneyPwdFlgByFirmId',
    data: {}
  },

  // 到期交收。临时接口
  param_getExpireTradeList: {
    url: '/intraday-trade-query/delivery/getExpireTradeList',
    data: {}
  },
  // 验收确认
  param_buyInspectionDeliveryConfirmt: {
    url: '/intraday-delivery/manage/user/buyInspectionDeliveryConfirm',
    data: {}
  },
  // 收货确认
  param_buyCloseDeliveryConfirm: {
    url: '/intraday-delivery/manage/user/buyCloseDeliveryConfirm',
    data: {}
  },
  // 成交历史
  queryUserClinchHS: {
    url: '/base-desk-statement/tradeQueryH/queryTradeFrontH',
    data: {
      page: '0',
      size: '20',
      // "commodityId": "1",
      tradeType: null,
      sort: [
        {
          direction: 'DESC',
          property: 'tradeId'
        }
      ]
    }
  },
  // 成交历史
  queryUserClinchHSNew: {
    url: '/base-desk-statement/tradeQueryH/queryTradeFrontH',
    data: {
      page: '0',
      size: '20',
      // "commodityId": "1",
      tradeType: null,
      sort: [
        {
          direction: 'DESC',
          property: 'tradeId'
        }
      ]
    }
  },
 
  // 查询收获地址
  param_getUserAddress: {
    url: '/base-address/address/getUserAddress',
    param: {
      // addressId: null, // 收货地址表主键 false
      // defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是) false
    }
  },
  // 删除收货地址
  param_deleteUserAddress: {
    url: '/base-address/address/deleteUserAddress',
    param: {
      addressId: null // 收货地址表主键
    }
  },
  // 编辑收获地址
  param_updateUserAddress: {
    url: '/base-address/address/updateUserAddress',
    param: {
      addressName: '', // 收货地址
      defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是)
      postCode: '', // 邮政编码
      recipients: '', // 收货人
      recipientsCellphone: '', //	收货人电话
      region: '' // 地区(前端维护辅助字段)
    }
  },
  // 地址管理
  // 新增收货地址
  param_saveUserAddress: {
    // url: '/base-address/address/saveUserAddress',
    url: '/base-address/address/saveUserAddress',
    param: {
      addressName: '', // 收货地址
      defaultFlag: 0, // 是否设置为默认收获地址 (0:否 1:是)
      postCode: '', // 邮政编码
      recipients: '', // 收货人
      recipientsCellphone: '', //	收货人电话
      region: '' // 地区(前端维护辅助字段)
    }
  },
  // 修改资金密码
  param_updateMoneyPassword: {
    // url: '/intraday-marketing-system/operate/updateFundPwd',
    url: '/intraday-marketing-system/operate/updateFundPwdEnd',
    param: {
      // 'moneytoken': '',
      // 'newmoneytoken': ''
      oldPwd: '',
      newPassWord: '',
      bankId: ''
    }
  },
  /**现货买进 */
  // 新增个人开户审核(认证)
  param_savePersonAccountAudit: {
    url: '/intraday-marketing-system/frontAuditController/savePersonAccountAudit',
    param: {
      certNo: '', //证据号码
      certType: '1', //证据类型 1:身份证
      contactAddress: '', //联系地址
      idCartFrontImg: '', //身份证正面照片
      idCartNegativeImg: '', //身份证反面照片
      realName: '', //真实姓名
      urgencyContact: '', //	紧急联系人
      urgencyContactPhone: '' //紧急联系人手机号
    }
  },
  // 新增企业开户审核(认证)
  param_saveEnterpriseAccountAudit: {
    url: '/intraday-marketing-system/frontAuditController/saveEnterpriseAccountAudit',
    param: {
      companyCertCode: '', //公司证件代码
      companyCertImage: '', //公司证件照片
      companyCertType: '', //公司证件类型 1:营业执照号 2:组织机构代码 3:社会统一代码
      contactAddress: '', //联系地址
      idCartFrontImg: '', //身份证正面照片
      idCartNegativeImg: '', //身份证反面照片
      legalPersonCertNo: '', //法人证件号码
      legalPersonCertType: 1, //法人证据类型 1:身份证
      urgencyContact: '', //	紧急联系人
      urgencyContactPhone: '' //紧急联系人手机号
    }
  },
  // 查询认证信息
  param_findCertificationInfo: {
    url: '/intraday-marketing-system/frontAuditController/findCertificationInfo',
    param: {}
  },
  // 获取银行列表
  param_queryBank: {
    url: '/intraday-margin-query/marginQuery/findBank',
    param: {}
  },
  // 获取签约银行列表
  param_findSignBank: {
    url: '/intraday-margin-query/marginQuery/findSignBank',
    param: {}
  },
  // 签约
  param_userSign: {
    url: '/intraday-monibank/monibank/userSign',
    param: {
      bankId: '',
      bankAccount: '', // 银行卡号
      bankAccountName: '', // 账户名称
      fundPwd: '', // 资金密码
      openBankName: '', // 开户行名称
      openBankNum: '' // 开户行行号
    }
  },
  // 解约
  param_userUnSign: {
    url: '/intraday-monibank/monibank/userUnSign',
    param: {
      firmId: firmId,
      bankAccount: '', // 银行卡号
      bankId: ''
    }
  },
  // 出金
  // param_fundOutByMarket: {
  //   url: '/intraday-bankchannel/qilubank/fundOutByMarket',
  //   param: {
  //     firmId: Number(firmId),
  //     amount: '',
  //     pwd: '',
  //     bankId: ''
  //   }
  // },
  param_fundOutByMarket: {
    // 'url': '/third-bank-bankchannel/bank/outFundApply',
    'url': '/abc-bank-channel/fund/fundOutByMarket',
    'param': {
      // // 'firmId': Number(firmId),
      // 'transactionAmount': '',
      // 'memo': '',
      // 'channelFlag': ''
    }
  },
   // 出金申请
   param_outFundApply: {
    'url': '/third-bank-bankchannel/bank/outFundApply',
    'param': {
      'transactionAmount': '',
      'memo': ''
    }
  },
  // 转让
  param_transfer: {
    url: '/intraday-trade/trade/transfer',
    data: {
      holdDetailId: 0, //持仓明细id
      price: 0,
      quantity: 0
    }
  },
  // 汇总转让
  param_holdTransfer: {
    url: '/intraday-trade/trade/holdTransfer',
    data: {
      holdId: 0, //持仓汇总id
      price: 0,
      quantity: 0
    }
  },
  // 现货买进转让
  param_tqTransfer: {
    url: '/intraday-trade/trade/tqTransfer',
    data: {
      holdDetailId: 0, //持仓明细id
      price: 0,
      quantity: 0
    }
  },
  // 商品策略查询
  param_queryCommodityStrategy: {
    url: '/intraday-trade-query/strategy/queryCommodityStrategy',
    param: {}
  },
  // 当前交收
  param_getDeliveryList: {
    url: '/intraday-trade-query-mongo/frontTradeController/getDeliveryList',
    data: {
      page: 0,
      size: 10,
      sort: [
        {
          direction: 'DESC',
          property: 'deliveryId'
        }
      ]
      
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 当前交收导出
  param_getDeliveryExcel: {
    url: '/intraday-trade-query-mongo/frontTradeController/getDeliveryExcel',
    param: {}
  },
  // 历史交收成交导出
  param_exportDeliveryFrontH: {
    url: '/intraday-trade-query-mongo/tradeQueryH/exportDeliveryFrontH',
    param: {  
    }
  },
  // 历史交收
  param_getDeliveryListH: {
    url: '/intraday-trade-query-mongo/tradeQueryH/queryDeliveryFrontH',
    data: {
      page: 0,
      size: 10,
      sort: [
        {
          direction: 'DESC',
          property: 'deliveryId'
        }
      ]
    }
  },
  // 2020.10.26 现货买进交收撤销
  param_auditFirmDelivery: {
    url: '/intraday-delivery/manage/user/auditFirmDelivery',
    data: {
      deliveryId: null
    }
  },
  // 历史交收
  param_getDeliveryHList: {
    url: '/intraday-trade-query/delivery/getDeliveryHList',
    data: {
      page: 0,
      size: 10
      // "sort": [
      //   {
      //     "direction": "",
      //     "property": ""
      //   }
      // ],
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 提货记录
  param_getPickList: {
    url: '/intraday-trade-query-mongo/mongoQuery/getPickList',
    data: {
      page: 0,
      size: 10
      // "sort": [
      //   {
      //     "direction": "",
      //     "property": ""
      //   }
      // ],
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 仓单修改发货信息
  param_updateReceivingInfo: {
    // 'url': '/base-warehousereceipt/delivery/updateReceivingInfo',
    'url': '/base-desk-manage/delivery/updateReceivingInfo',
    'data': {}
  },
  // 仓单修改发货信息
  // param_updateReceivingInfo: {
  //   'url': '/base-desk-manage/delivery/updateReceivingInfo',
  //   'data': {}
  // },
  // 查看物流详情
  param_getLogistic: {
    'url': '/shop-desk/aliDelivery/getLogistic',
    'data': {}
  },
  // 仓单物流确认收货
  param_confirmReceipt: {
    'url': '/base-desk-manage/delivery/confirmReceipt',
    'data': {}
  },
  // 仓单记录
  param_getWarehouseList: {
    url: '/intraday-trade-query-mongo/delivery/getWarehouseList',
    data: {
      page: 0,
      size: 10
      // "sort": [
      //   {
      //     "direction": "",
      //     "property": ""
      //   }
      // ],
      // "endTime": 0,
      // "startTime": 0
    }
  },
  // 提货申请
  param_addPick: {
    url: '/base-desk-manage/delivery/addDelivery',
    data: {
      deliveryQuantity: 0, //提货数量
      isCheck: 1,
      consigneeName: '', //联系人
      consigneePhone: '', //联系方式
      warehousId: 0 //仓单id
    }
  },
  //现货买进明细交收（前台）
  param_addDeliveryDetail: {
    url: '/intraday-delivery/manage/user/addDeliveryDetail',
    data: {
      // "deliveryPrice": 0,//交收价格
      deliveryQuantity: 0, //交收数量
      holdDetailId: 0, //持仓明细（按汇总交收传null）
      holdId: null
    }
  },
  // 范围撤单
  param_rangeCancel: {
    url: '/intraday-trade/trade/rangeCancel',
    param: {
      commodityId: 0,
      highPrice: 0,
      lowPrice: 0
    }
  },
  // 快捷转让(平仓)
  param_fastClose: {
    url: '/intraday-trade/trade/fastClose',
    param: {
      bsFlag: null,
      commodityId: 0,
      price: 0,
      quantity: 0
    }
  },
  // 快捷现货买进转让(平仓)
  param_fastCloseTq: {
    url: '/intraday-trade/trade/fastCloseTq',
    param: {
      bsFlag: null,
      commodityId: 0,
      price: 0,
      quantity: 0
    }
  },
  // 市场状态和公告id查询
  param_queryContentSystem: {
    url: '/intraday-trade-query/query/queryContentSystem',
    param: {}
  },
  // 查询服务时间
  param_queryServerTime: {
    url: '/intraday-trade-query/query/queryServerTime',
    param: {}
  },
  // 查询总盈亏 用户成交id盈亏查询
  param_queryTradeClosepl: {
    url: '/intraday-trade-query-mongo/query/queryTradeClosepl',
    param: {}
  },
  // 查询v2心跳
  param_v2_queryTradeClosepl: {
    url: '/intraday-trade-query-mongo/query/v2/queryTradeClosepl',
    param: {}
  },
  // 查询订立参数
  param_findConcludeStage: {
    url: '/intraday-trade-query-mongo/delivery/findConcludeStageData',
    param: {
      commodityId: null
    }
  },
  // 商品涨停跌停价查询
  findCommodityHighLow: {
    url: '/intraday-trade-query/query/findCommodityHighLow',
    data: {
      commodityId: 0
    }
  },
  // 当日资金流水查询
  queryFirmAccountFundsFlow: {
    url: '/base-margin-front-queryservice/margin/queryFirmAccountFundsFlow',
    param: {
      page: 1,
      size:10,
      endTime:null,
      starTime:null,
      symbolId: 1
    }
  },
  // 历史资金流水查询
  queryFirmAccountFundsFlowH: {
    url: '/base-desk-statement/margin/findAccountFundsFlowHFront',
    // url: '/base-statement/margin/findAccountFundsFlowHFront',
    param: {
      page: 1,
      size:10,
      symbolId: 1
    }
  },

  // 用户结算单查询
  param_queryStatements: {
    url: '/intraday-marketing-system/frontUserExport/queryStatements',
    param: {
      page: 0,
      size: 1
    },
    data: {
      page: 0,
      size: 1
    }
  },
  // 用户结算单下载
  param_statementsDownload: {
    url: '/intraday-marketing-system/frontUserExport/statementsDownload',
    param: {
      tradeDay: null
    }
  },
  /****************铺货选货相关查询 ***************/
  //配对查询
  param_getPair: {
    url: '/intraday-trade-query-mongo/tradeQuery/querySettlementDelivery',
    param: {
      page: '1',
      size: '10'
      // 'sort':'createTime,desc'
    }
  },
  //选货(查询所有铺货信息)
  param_getSelection: {
    url: '/intraday-trade-query-mongo/spreadOrSelection/getSelection',
    param: {
      page: '1',
      size: '10'
      // 'sort':'createTime,desc'
    }
  },
  //铺货(查询所有选货信息)
  param_getSpread: {
    url: '/intraday-trade-query-mongo/spreadOrSelection/getSpread',
    param: {
      page: '1',
      size: '10'
      // 'sort':'createTime,desc'
    }
  },
  //铺货查询
  param_getSpreadQuery: {
    url: '/intraday-trade-query-mongo/tradeQuery/querySettlementDelivery',
    param: {
      page: '1',
      size: '10'
      // 'sort':'createTime,desc'
    }
  },
  /****************铺货选货相关查询 end***************/
  /****************铺货选货相关操作 ***************/
  //选货
  param_selectionGoods: {
    url: '/intraday-delivery/manage/user/selectionGoods',
    // url: '/intraday-trade/trade/selectionGoods',
    param: {
      commodityId: 0, //商品id
      quantity: 0, //数量
      spreadGoodsId: 0 //铺货表主键(选货时传)
      // "storageId": 0,//仓库编号（铺货时传）
      // "warehouseId": 0//仓单编号（铺货时传）
    }
  },
  // 铺货
  param_spreadGoods: {
    url: '/intraday-delivery/manage/settlementUser/applySettlementDelivery',
    // url: '/intraday-trade/trade/spreadGoods',
    param: {
      commodityId: 0, //商品id
      quantity: 0, //数量
      // "spreadGoodsId": 0,//铺货表主键(选货时传)
      // storageId: 1, //仓库编号（铺货时传）
      // warehouseId: 0 //仓单编号（铺货时传）
    }
  },
  // 铺货撤销
  param_deleteSpreadGoods: {
    url: '/intraday-delivery/manage/user/deleteSpreadGoods',
    // url: '/intraday-trade/trade/deleteSpreadGoods',
    param: {
      spreadGoodsId: 0
      // "spreadGoodsIds": []
    }
  },
  // 铺货撤销
  param_deleteBatchSpreadGoods: {
    url: '/intraday-delivery/manage/user/deleteBatchSpreadGoods',
    // url: '/intraday-trade/trade/deleteBatchSpreadGoods',
    param: {
      // "spreadGoodsId": 0,
      spreadGoodsIds: []
    }
  },
  /****************铺货选货相关操作 end***************/

  // 提货单
  param_getBillOfLoading: {
    url: '/intraday-trade-query-mongo/delivery/getBillOfLoading',
    param: {
      deliveryId: null //提货表主建
    }
  },
  // pc扫码跳移动端秘钥 ---- 更换手机号码 --- 视频没有超过五次
  param_getSessionKey: {
    url: '/base-desk-query/userSession/getSessionKey?type=1',
    param: {

    }
  },
  // 视频超过五次进入人工审核
  param_getSessionKey1: {
    url: '/base-desk-query/userSession/getSessionKey?type=2',
    param: {

    }
  },
  // 修改登录
  param_getSessionKey2: {
    url: '/base-desk-query/userSession/getSessionKey?type=3',
    param: {

    }
  },
  // 修改资金
  param_getSessionKey3: {
    url: '/base-desk-query/userSession/getSessionKey?type=4',
    param: {

    }
  },
  // 个人签约
  param_getSessionKey4: {
    url: '/base-desk-query/userSession/getSessionKey?type=5',
    param: {

    }
  },
  // 企业签约
  param_getSessionKey5: {
    url: '/base-desk-query/userSession/getSessionKey?type=6',
    param: {

    }
  },
  // 开户
  param_getSessionKeyOpen: {
    url: '',
    param: {

    }
  },
  // 查询用户具体状态
  param_queryUserStatus: {
    url: '/base-desk-manage/user/queryUserStatus',
    param: {

    }
  },
  // 获取站内信
  param_getWebsiteMessage: {
    url: '/stationmsg/internal/postMsgInternal',
    param: {
      sort: [
        {
          direction: 'DESC',
          property: 'createTime'
        }
      ]
    }
  },
  // 查看对手方手机号
  param_getAnalogueMobile: {
    url: '/intraday-trade-query-bak/tradeQuery/getOrderContractInfo',
    param: {
      bsFlag: '', // 买卖方向
      commodityId: 0, // 商品id
      price: 0, // 订立单价
      quantity: 0 // 订立数量
    }
  },

  // 忘记资金密码
  param_forgetPws: {
    url: '/base-margin-service/margin/updateFundPwdEndUserSMS',
    param: {
      bankId: 21
    }
  },
  // 发送短信
  param_sendMes: {
    url: '/base-margin-service/margin/sendSMS',
    param: {
      bankId: 21
    }
  },
  // 忘记登录密码
  param_forgetLoginPwd: {
    url: '/authn/authn/v1/frontForgetPwd',
    param: {
      checkWay: 1,
      templateId: 49
    }
  },
  // 查询签约银行(恒丰/农行)
  param_findBankAccount: {
    url: '/intraday-margin-query/bankCacheQuery/findBankAccount',
    param: {}
  },

  // 登陆短信提示接口
  param_sendMsgLoginInformation: {
    url: 'authn/authn/sendMsgLoginInformation',
    param: {
      title: '',
      type: 1,
      templateId: 50,
      params: [new Date(), 'pc端']
    }
  },


  // 行情
  // 新增自选
  param_addCommodityFirmMark: {
    url: '/intraday-trade-manage/commodityMark/addCommodityFirmMark',
    param: {
      commodityId: null // Integer
    }
  },
  // 删除自选
  param_deleteCommodityFirmMark: {
    url: '/intraday-trade-manage/commodityMark/deleteCommodityFirmMark',
    param: {
      commodityId: null // Integer
    }
  },
  // 查询自选
  param_findSymbolMarkList: {
    url: '/intraday-trade-query-mongo/frontTradeController/findSymbolMarkList',
    param: {}
  },
  // 设置止盈止损(持仓明细)
  param_addStopPrice: {
    url: '/intraday-trade/trade/addStopPrice',
    param: {
      holdDetailId: 0,
      stopLossPrice: 0,
      stopProfitPrice: 0
    }
  },
  // 撤销止盈止损 设置那个为0代表撤销止盈或止损
  param_setStopPrice: {
    url: '/intraday-trade/trade/setStopPrice',
    param: {
      // "stopLossPrice": 0,
      // "stopProfitPrice": 0
    }
  },
  // 导出 当日委托
  param_tq_tradeQuery_exportOrderFront: {
    url: '/intraday-trade-query-mongo/tradeQuery/exportOrderNewFront',
    param: {
    
    }
  },
  // 导出 历史委托
  param_tq_tradeQuery_exportOrderFrontH: {
    url: '/intraday-trade-query-mongo/tradeQueryH/exportOrderFrontH',
    param: {
    
    }
  },
  // 导出 当日成交
  param_tq_tradeQuery_exportTradeList: {
    url: '/intraday-trade-query-mongo/tradeQuery/exportTradeNewList',
    param: {
    
    }
  },
  // 导出 历史成交
  param_tq_tradeQuery_exportTradeFrontH: {
    // url: '/intraday-trade-query-mongo/tradeQuery/exportTradeFrontH',
    url: '/intraday-trade-query-mongo/tradeQueryH/exportTradeFrontH',
    param: {
    
    }
  },
  // 导出 持仓明细
  param_tq_tradeQuery_exportHoldDetailList: {
    url: '/intraday-trade-query-mongo/tradeQuery/exportHoldDetailNewList',
    param: {
    
    }
  },
  // 导出 持仓汇总
  param_tq_tradeQuery_exportHoldFront: {
    url: '/intraday-trade-query-mongo/tradeQuery/exportHoldFront',
    param: {
    
    }
  },
  // 交收订货
  param_tq_queryDeliveryStock: {
    url: '/intraday-trade-query-bak/tradeQuery/queryDeliveryStock',
    data: {
    
    }
  },
  // 交收订货 导出
  param_tq_exportDeliveryStock: {
    url: '/intraday-trade-query-bak/tradeQuery/exportDeliveryStock',
    param: {
    
    }
  },
  // 当前资金 导出
  param_tq_exportFirmAccountFundsFlow: {
    url: '/base-margin-front-queryservice/margin/exportFirmAccountFundsFlow',
    param: {
    
    }
  },
  // 历史资金 导出
  param_tq_exportFirmAccountFundsFlowH: {
    url: '/base-margin-front-queryservice/margin/exportFirmAccountFundsFlowH',
    param: {
    
    }
  },
  // 报表系统 订单报表 -资金状况
  param_findUserReportOrderMargin: {
    url: '/intraday-trade-query/query/findUserReportOrderMargin',
    data: {
      'startDate':null,
      'endDate': null
    
    }
  },
   // 资金状况 导出
  param_tq_exportUserReportOrderMargin: {
    url: '/intraday-trade-query/query/exportUserReportOrderMargin',
    param: {
    
    }
  },
  // 到期交付 导出
  param_tq_exportExpireTradeList: {
    url: '/intraday-trade-query/delivery/exportExpireTradeList',
    param: {}
  },
  // 获取Top用户名称
  param_tq_queryTopUserName: {
    url: '/intraday-trade-query/query/queryTopUserName',
    param: {}
  },

  //  --------------------- 通用银行开始-------------
  // 入金展示信息
  param_showInFundInfo: {
    url: bankServe + '/fund/showInFundInfo',
    param: {}
  },
  // 本行入金
  param_fundInByMarket: {
    url: bankServe + '/fund/fundInByMarket',
    param: {}
  },
  // 出金 币种id写死人民币: 1
  param_fundOutByMarket: {
    url: bankServe + '/fund/fundOutByMarket',
    param: {}
  },
//  --------------------- 通用银行结束-------------
  // 查询补充营业执照信息
  param_queryUserCompanyInformation: {
    url: '/intraday-trade-query-mongo/query/queryUserCompanyInformation',
    param: {
    }
  },
  // 查询延期审核补充信息状态
  param_queryUserDelayAudit: {
    url: '/intraday-trade-query-mongo/query/queryUserDelayAudit',
    param: {
    }
  },
  // 查询查询用户注册时间和补充期限
  param_queryUserCreateTimeAndDeadline: {
    url: '/intraday-trade-query-mongo/query/queryUserCreateTimeAndDeadline',
    param: {
    }
  },
    /****************************二维码登录******************************** */
  // 生成登录二维码 免session (或查询)
  param_getScanCode: {
    'url': '/authn/authn/v1/getScanCode',
    'param': {
      scanCode: null
    }
  },
  // 轮询登录二维码
  param_getScanCode1: {
    'url': '/authn/authn/v1/getScanCode',
    'param': {
      scanCode: null
    }
  },
  /****************************二维码登录end******************************** */
  // 获取配置信息
  param_queryItemConfigs: {
    url: '/base-desk-query/baseItemConfig/queryItemConfigs',
    param: {
      type: 1
    }
  }
}
